/* import __COLOCATED_TEMPLATE__ from './phone-details-call-recording.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';
import type { CallRecording } from 'embercom/objects/inbox/call-recording';

interface PhoneDetailsCallRecordingSignature {
  Args: {
    recording: CallRecording;
    onPlay: () => void;
  };
  Element: HTMLDivElement;
}

const PhoneDetailsCallRecording = templateOnlyComponent<PhoneDetailsCallRecordingSignature>();

export default PhoneDetailsCallRecording;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::PhoneDetailsCallRecording': typeof PhoneDetailsCallRecording;
    'inbox2/phone-details-call-recording': typeof PhoneDetailsCallRecording;
  }
}
